/*
 * @Author: Jing
 * @Date: 2021-12-17 17:22:29
 * @Descripttion: env 配置文件
 */
import { GlobEnvConfig } from '#/config'

export function getAppEnvConfig() {
    const ENV = import.meta.env as unknown as GlobEnvConfig
    const { VITE_API_BASE_URL, VITE_COOKIE_KEY, NODE_ENV } = ENV
    return {
        VITE_API_BASE_URL,
        VITE_COOKIE_KEY,
        NODE_ENV,
    }
}
